export default {
  addQuote(state, data) {
    const newQuoteIdx = state.preventivi.findIndex(
      (quote) => quote.id === data.id
    );
    if (newQuoteIdx === -1) {
      state.preventivi.push(data);
    } else {
      state.preventivi[newQuoteIdx] = data;
    }
  },

  updateTipologie(state, data) {
    state.tipologie = data;
  },

  async updateTipiPersona(state, data) {
    state.tipiPersona = data;
  },

  async updateMezzi(state, data) {
    state.mezzi = data;
  },

  async updateServizi(state, data) {
    state.servizi = data;
  },

  async updateServiziForm(state, data) {
    state.serviziForm = data;
  },
};
